import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveCostProfileRequestFailure({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isRemoveCostProfileRequestPending({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isPending : false;
    },
    isRemoveCostProfileRequestSuccess({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
